import translation from "./translation";

const my = {
  translation,
};

export default my;
